/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as SiteRouteImport } from './routes/_site'
import { Route as SiteIndexRouteImport } from './routes/_site/index'
import { Route as SiteProjectNameIndexRouteImport } from './routes/_site/$projectName/index'
import { Route as SiteProjectNameVersionRouteImport } from './routes/_site/$projectName/$version'
import { Route as SiteProjectNameVersionSplatRouteImport } from './routes/_site/$projectName/$version.$'

const AdminIndexLazyRouteImport = createFileRoute('/admin/')()
const AdminSplatLazyRouteImport = createFileRoute('/admin/$')()

const SiteRoute = SiteRouteImport.update({
  id: '/_site',
  getParentRoute: () => rootRouteImport,
} as any)
const SiteIndexRoute = SiteIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SiteRoute,
} as any).lazy(() => import('./routes/_site/index.lazy').then((d) => d.Route))
const AdminIndexLazyRoute = AdminIndexLazyRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/admin/index.lazy').then((d) => d.Route))
const AdminSplatLazyRoute = AdminSplatLazyRouteImport.update({
  id: '/admin/$',
  path: '/admin/$',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/admin/$.lazy').then((d) => d.Route))
const SiteProjectNameIndexRoute = SiteProjectNameIndexRouteImport.update({
  id: '/$projectName/',
  path: '/$projectName/',
  getParentRoute: () => SiteRoute,
} as any)
const SiteProjectNameVersionRoute = SiteProjectNameVersionRouteImport.update({
  id: '/$projectName/$version',
  path: '/$projectName/$version',
  getParentRoute: () => SiteRoute,
} as any)
const SiteProjectNameVersionSplatRoute =
  SiteProjectNameVersionSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => SiteProjectNameVersionRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof SiteIndexRoute
  '/admin/$': typeof AdminSplatLazyRoute
  '/admin/': typeof AdminIndexLazyRoute
  '/$projectName/$version': typeof SiteProjectNameVersionRouteWithChildren
  '/$projectName/': typeof SiteProjectNameIndexRoute
  '/$projectName/$version/$': typeof SiteProjectNameVersionSplatRoute
}
export interface FileRoutesByTo {
  '/admin/$': typeof AdminSplatLazyRoute
  '/': typeof SiteIndexRoute
  '/admin': typeof AdminIndexLazyRoute
  '/$projectName/$version': typeof SiteProjectNameVersionRouteWithChildren
  '/$projectName': typeof SiteProjectNameIndexRoute
  '/$projectName/$version/$': typeof SiteProjectNameVersionSplatRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_site': typeof SiteRouteWithChildren
  '/admin/$': typeof AdminSplatLazyRoute
  '/_site/': typeof SiteIndexRoute
  '/admin/': typeof AdminIndexLazyRoute
  '/_site/$projectName/$version': typeof SiteProjectNameVersionRouteWithChildren
  '/_site/$projectName/': typeof SiteProjectNameIndexRoute
  '/_site/$projectName/$version/$': typeof SiteProjectNameVersionSplatRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin/$'
    | '/admin/'
    | '/$projectName/$version'
    | '/$projectName/'
    | '/$projectName/$version/$'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/admin/$'
    | '/'
    | '/admin'
    | '/$projectName/$version'
    | '/$projectName'
    | '/$projectName/$version/$'
  id:
    | '__root__'
    | '/_site'
    | '/admin/$'
    | '/_site/'
    | '/admin/'
    | '/_site/$projectName/$version'
    | '/_site/$projectName/'
    | '/_site/$projectName/$version/$'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SiteRoute: typeof SiteRouteWithChildren
  AdminSplatLazyRoute: typeof AdminSplatLazyRoute
  AdminIndexLazyRoute: typeof AdminIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_site': {
      id: '/_site'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_site/': {
      id: '/_site/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof SiteIndexRouteImport
      parentRoute: typeof SiteRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/$': {
      id: '/admin/$'
      path: '/admin/$'
      fullPath: '/admin/$'
      preLoaderRoute: typeof AdminSplatLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_site/$projectName/': {
      id: '/_site/$projectName/'
      path: '/$projectName'
      fullPath: '/$projectName/'
      preLoaderRoute: typeof SiteProjectNameIndexRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/$projectName/$version': {
      id: '/_site/$projectName/$version'
      path: '/$projectName/$version'
      fullPath: '/$projectName/$version'
      preLoaderRoute: typeof SiteProjectNameVersionRouteImport
      parentRoute: typeof SiteRoute
    }
    '/_site/$projectName/$version/$': {
      id: '/_site/$projectName/$version/$'
      path: '/$'
      fullPath: '/$projectName/$version/$'
      preLoaderRoute: typeof SiteProjectNameVersionSplatRouteImport
      parentRoute: typeof SiteProjectNameVersionRoute
    }
  }
}

interface SiteProjectNameVersionRouteChildren {
  SiteProjectNameVersionSplatRoute: typeof SiteProjectNameVersionSplatRoute
}

const SiteProjectNameVersionRouteChildren: SiteProjectNameVersionRouteChildren =
  {
    SiteProjectNameVersionSplatRoute: SiteProjectNameVersionSplatRoute,
  }

const SiteProjectNameVersionRouteWithChildren =
  SiteProjectNameVersionRoute._addFileChildren(
    SiteProjectNameVersionRouteChildren,
  )

interface SiteRouteChildren {
  SiteIndexRoute: typeof SiteIndexRoute
  SiteProjectNameVersionRoute: typeof SiteProjectNameVersionRouteWithChildren
  SiteProjectNameIndexRoute: typeof SiteProjectNameIndexRoute
}

const SiteRouteChildren: SiteRouteChildren = {
  SiteIndexRoute: SiteIndexRoute,
  SiteProjectNameVersionRoute: SiteProjectNameVersionRouteWithChildren,
  SiteProjectNameIndexRoute: SiteProjectNameIndexRoute,
}

const SiteRouteWithChildren = SiteRoute._addFileChildren(SiteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SiteRoute: SiteRouteWithChildren,
  AdminSplatLazyRoute: AdminSplatLazyRoute,
  AdminIndexLazyRoute: AdminIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
